import styled from 'styled-components';
import { Box } from 'pcln-design-system';
export const LoadMorePromptsWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ChatDialogContentstyles__LoadMorePromptsWrapper",
  componentId: "sc-1czc5zo-0"
})(["text-align:center;display:inline-flex;justify-content:center;margin-bottom:20px;"]);
export const LoadMorePrompts = /*#__PURE__*/styled(Box).withConfig({
  displayName: "ChatDialogContentstyles__LoadMorePrompts",
  componentId: "sc-1czc5zo-1"
})(["cursor:pointer;"]);